import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

import { useSnowflakePing, useWhoami } from "../api";

export function WhoamiPage() {
  const whoami = useWhoami();
  const snowflake = useSnowflakePing();

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Whoami</h1>
        <p className="text-sm text-muted-foreground">
          Smoke-test feature that exercises auth, permissions, and Snowflake.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Identity</CardTitle>
          <CardDescription>From /api/whoami</CardDescription>
        </CardHeader>
        <CardContent>
          {whoami.isLoading ? (
            <p className="text-sm text-muted-foreground">Loading…</p>
          ) : whoami.error ? (
            <p className="text-sm text-destructive">{String(whoami.error)}</p>
          ) : whoami.data ? (
            <pre className="overflow-auto rounded-md bg-muted p-3 text-xs">
              {JSON.stringify(whoami.data, null, 2)}
            </pre>
          ) : null}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Snowflake ping</CardTitle>
          <CardDescription>
            Runs SELECT CURRENT_USER(), CURRENT_ROLE(), GETVARIABLE(&apos;COMPANY_IDS&apos;)
            through core.snowflake.query
          </CardDescription>
        </CardHeader>
        <CardContent>
          {snowflake.isLoading ? (
            <p className="text-sm text-muted-foreground">Loading…</p>
          ) : snowflake.error ? (
            <p className="text-sm text-destructive">
              {snowflake.error instanceof Error ? snowflake.error.message : String(snowflake.error)}
            </p>
          ) : snowflake.data ? (
            <pre className="overflow-auto rounded-md bg-muted p-3 text-xs">
              {JSON.stringify(snowflake.data, null, 2)}
            </pre>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
